import { useSelector } from 'react-redux';

export const useShouldTestNetwork = () => {
  const { scenario } = useSelector((state) => state.scenario);
  const { video, microphone, speaker, network, connection } = useSelector(
    (state) => state.status
  );
  // This will return true if the conditions predict that the network test should be run
  // Only do network test for agents (dashboard) and if no prior errors
  const doNetworkTest =
    scenario === 'dashboard' &&
    !video &&
    !microphone &&
    !speaker &&
    !network &&
    !connection;

  return { doNetworkTest };
};
